import React, {FC} from 'react'
import classNames from 'classnames'
import {FileType, GoogleManagerTagClassNames} from '@/constants'
import {Button, Icon} from '@/components'
import {DOWNLOAD_ICON} from '@/constants/playwright-ids'

import {DownloadButtonsProps} from './props'
import styles from './styles.scss'

export const DownloadButtons: FC<DownloadButtonsProps> = ({
    className,
    menuItems,
    onMenuItemClick
}) => {
    const pdfItem = menuItems.find(({key}) => key === FileType.PDF)
    const otherItems = menuItems.filter(({key}) => key !== FileType.PDF)

    return (
        <div className={styles.downloadButtonsContainer}>
            {pdfItem && (
                <Button
                    type='default'
                    title={String(pdfItem.key)}
                    className={classNames(
                        styles.pdfButton,
                        className,
                        GoogleManagerTagClassNames.settlements.downloadButtons(
                            pdfItem.key as FileType
                        )
                    )}
                    icon={<Icon className={styles.pdfIcon} type={'statement_doc' as FileType} />}
                    onClick={() => onMenuItemClick(pdfItem.key as FileType)}
                    data-test-id={DOWNLOAD_ICON + '_' + pdfItem.key}
                >
                    {(pdfItem as any).label}
                </Button>
            )}
            {otherItems.map(({key}) => {
                const k = key as FileType

                return (
                    <Button
                        type='link'
                        key={k}
                        title={k}
                        className={classNames(
                            styles.button,
                            className,
                            GoogleManagerTagClassNames.settlements.downloadButtons(k)
                        )}
                        icon={<Icon style={{pointerEvents: 'none'}} type={k} />}
                        onClick={() => onMenuItemClick(k)}
                        data-test-id={DOWNLOAD_ICON + '_' + k}
                    ></Button>
                )
            })}
        </div>
    )
}
